import {
  SmartDpControllerSuggestionArgs,
  TechnicalSelection,
} from "@imi-ernd-be/hyselect-engine";
import { withDelete } from "@src/core/engine/helpers/withDelete";
import { isNotNil } from "@src/shared/helpers/guards";
import { buildEngineSelectedFilters } from "../../helpers/buildEngineSelectedFilters";
import { FilterGroupsState } from "../../technicalSelectionRepository";

export type SensorSelectionArgsOptions = {
  productId: string;
  subProductFilters: {
    dpStabilized?: number | null | undefined;
  } & FilterGroupsState;
  subProductType: "sensors";
};

export function initSensorSuggestionArgs(
  technicalSelection: TechnicalSelection,
  suggestionArgs: SmartDpControllerSuggestionArgs,
  options: SensorSelectionArgsOptions,
) {
  const sensorsFiltersEngine = buildEngineSelectedFilters(
    options.subProductFilters,
  );
  const sensorsFilterGroups = withDelete(
    [sensorsFiltersEngine],
    technicalSelection.getSensorsFilters(
      options.productId,
      sensorsFiltersEngine,
    ),
  );
  suggestionArgs.saveSensorsFilters(sensorsFilterGroups);
  if (isNotNil(options.subProductFilters.dpStabilized)) {
    suggestionArgs.dpStabilized = options.subProductFilters.dpStabilized;
  }
}
